const MessageRecherche = (props) => {


return (
    <div id="search">
        <label><i className="fa fa-search" aria-hidden="true"></i></label>
        <input type="text" placeholder="Rechercher..." value={props.search} onChange={(e) => props.setSearch(e.target.value)}/>&nbsp;&nbsp;
        <button  onClick={props.handleSearch} style={{backgroundColor:"#2c3e50", color:"white"}}><i className="material-icons"> Rechercher </i></button>
    </div>
)

}



export default MessageRecherche;
